import { postAPI } from '../helpers';
import { hesselApiTypes } from '../models/hessel-api';

export const postHireEmailCustomerAction = async (data: hesselApiTypes.HireEmailCustomerActionRequest): Promise<void> => {
    const queryString = new URLSearchParams(data).toString();
    await postAPI(`/api/v1/Proxy/hire-email-customer-action?${queryString}`);
};
